export default {
  buttons: [
    'X',
    'O',
    'Square',
    'Triangle',
    'L1',
    'R1',
    'L2',
    'R2',
    'Share',
    'Options',
    'L3',
    'R3',
    'UpArrow',
    'DownArrow',
    'LeftArrow',
    'RightArrow',
    'Ps',
    'TouchPad',
  ],
  buttonsDefault: {
    X: false,
    O: false,
    Square: false,
    Triangle: false,

    R1: false,
    R2: false,
    R3: false,

    L1: false,
    L2: false,
    L3: false,

    Options: false,
    Share: false,

    UpArrow: false,
    RightArrow: false,
    DownArrow: false,
    LeftArrow: false,

    Ps: false,
    TouchPad: false,
  },
  axis: ['LeftStickX', '-LeftStickY', 'RightStickX', '-RightStickY'],
  axisDefault: {
    LeftStickX: 0.0,
    LeftStickY: 0.0,

    RightStickX: 0.0,
    RightStickY: 0.0,

    RightTrigger: 0.0,
    LeftTrigger: 0.0,
  },
  buttonAxis: [
    null,
    null,
    null,
    null,
    null,
    null,
    'LeftTrigger',
    'RightTrigger',
  ],
};
